export default __webpack_public_path__ + "static/media/github.caf5cc55.svg";